import React, { memo, Fragment, useMemo } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { useLocale } from '@redlink/assets/locale';
import { Text, Icon, Space, Card } from '@redlink/components/atoms';

export const LinkTemplateItem = memo(
  ({ onSelect, index, item: { title, items } }) => {
    const { styles, colors } = useStyle();
    const { dictionary } = useLocale();

    const thumbnailItems = useMemo(
      () => items.filter(({ asThumbnail }) => asThumbnail),
      [items]
    );

    return (
      <TouchableOpacity
        activeOpacity={0.7}
        onPress={() => onSelect(title, index)}
      >
        <Card style={styles.container}>
          <View style={styles.iconsContainer}>
            {thumbnailItems.map(({ logoName }, index) => (
              <Fragment key={index}>
                <Icon name={logoName} color={colors.gray21} size={16} />
                <Space size={8} />
              </Fragment>
            ))}
          </View>
          <Space size={16} />
          <Text style={styles.title}>{dictionary[title]}</Text>
        </Card>
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    flex: 1,
    width: 140,
  },
  iconsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    fontSize: 14,
    color: colors.black,
  },
}));
